module.exports = __webpack_public_path__ + "img/IMG_9519_L_Foamcore.7aa6e912.jpg";